import L from 'leaflet'

export const apiCenter = (map, options) => {
  if (map) {
    map.map.panTo(new L.LatLng(options.lat, options.lng))
  }
}
